import script from "./releasesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./releasesTable.vue?vue&type=script&setup=true&lang=js"

import "./releasesTable.vue?vue&type=style&index=0&id=1a160435&lang=css"

const __exports__ = script;

export default __exports__